import {
  SET_LOAN_DETAILS_ACTION,
  SET_ALL_LOAN_DETAILS,
  SET_ANALYST_LOAN_DETAILS_ACTION,
  SET_EMI_CONFIGURATION_ACTION,
  CLEAR_SET_ALL_LOAN_DETAILS,
  SET_CREDIT_PRODUCT_INPUT_DATA,
  CLEAR_CREDIT_PRODUCT_INPUT_DATA,
  SET_BASIC_INFORMATION_DATA,
  SET_REFERENCES_DATA,
  CLEAR_BASIC_INFORMATION_DATA,
  CLEAR_REFERENCES_DATA,
  SET_FINANCIAL_INFORMATION_DATA,
  CLEAR_FINANCIAL_INFORMATION_DATA,
  SET_SITE_VISIT_DATA,
  CLEAR_SITE_VISIT_DATA,
  SET_EVIDENCE_DATA,
  CLEAR_EVIDENCE_DATA,
  SET_INCOME_DATA,
  SET_APPLY_LOAN_CONFIG_DATA,
  UPDATE_DOC_REQUIRE_CONFIG,
  SET_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT,
  CLEAR_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT,
  UPDATE_INVALID_FORM_FIELD,
  UPDATE_DOCPREFILL_DATA,
} from "../../redux/constants";

const INITIAL_STATE = {
  loanDetails: null,
  allLoanDetails: null,
  isHistory: false,
  creditProductDetails: {},
  creditProductInputDataForEdit: {},
  siteVisitDetails: {},
  documents: [],
  applyLoanConfig: {
    minimartCode: 0,
    loanApplicationId: 0,
    selectedTermIndex: 0,
    loanStatus: '',
    type: '',
    creditLimitData: '',
    docRequire: false,
    updateConsumerLoan: false,
    externalInvoiceRequire: false,
  },
  basicInfo: {
    ciCustomerSinceYears: null,
    businessEstablishedSinceYears: null,
    telephone: null,
    ownerName: null,
    ownerId: null,
    ownerAddress: null,
    ownerNumber: null,
    adminName: null,
    adminId: null,
    adminNumber: null,
    holder: "",
    ownerDateOfBirth: null,
    adminDateOfBirth: null,
    ciCreditLimit: null,
    prefillData: false,
    ownerHomeType: "",
    familyMembers: null,
    numberOfVehicles: null,
    bankAccount: false,
    bankDetail: null,
    receivesRemittances: false,
    remittanceDetails: null,
    socialMediaAccount: false,
    socialMediaAccountDetails: null,
    homeLocation: null,
    adminSince: null,
    adminAddress: null,
    adminSalary: null,
    businessType: null,
  },
  loanInfo: {
    prefillData: false,
    amountRequested: 0,
    amountApproved: 0,
    termRequested: 0,
    emi: 0,
    interestRate: 0,
    type: 0,
    invoiceNumber: 0,
    selectedTerm: 0,
    supplierName: '',
    productCost: 0,
    frequency: '',
    selectedDisbursementType: null,
    supplierDetails: null,
    selectedTransferAccountType: null,
    accountInfo: null,
    supplierId: null,
    collectionDays: null,
    currentEmi: 0,
    startDate: null,
    endDate: null,
    ilaff: 1,
  },
  additionalInfo: {
    prefillData: false,
    comercialRef1: {
      name: null,
      address: null,
      phone: null,
    },
    comercialRef2: {
      name: null,
      address: null,
      phone: null,
    },
    personalRef1: {
      name: null,
      address: null,
      phone: null,
    },
    personalRef2: {
      name: null,
      address: null,
      phone: null,
    },
    neighbourhoodRef1: {
      name: null,
      address: null,
      phone: null,
    },
    neighbourhoodRef2: {
      name: null,
      address: null,
      phone: null,
    },
  },
  income: {
    monthlyIncome: '',
    monthlySalesAmount: '',
    accountsPending: '',
    inventory: '',
  },
  expenses: {
    prefillData: false,
    numberOfEmployees: '',
    salaryOfEmployees: '',
    rent: '',
    electricity: '',
    water: '',
    telephone: '',
    internet: '',
    gas: '',
    debtsToSuppliers: '',
  },
  docPrefillData: false,
  creditLimits: [],
  siteVisit: {
    prefillData: false,
    numberOfMotors: '',
    numberOfFreezers: '',
    numberOfExhibitors: '',
    numberOfBotellero: '',
    numberOfFridges: '',
    numberOfTelephones: '',
    numberOfCars: '',
    numberOfTVs: '',
    localType: 'RENTED',
    investor: false,
    roofType: '',
  },
  invalidFormField: [],
};

export default function LoanDetailsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LOAN_DETAILS_ACTION:
      return {
        ...state,
        loanDetails: action.loanDetails,
      };
    case SET_ANALYST_LOAN_DETAILS_ACTION:
      return {
        ...state,
        analystLoanDetails: action.loanDetails,
        isHistory: action.isHistory,
      };
    case SET_EMI_CONFIGURATION_ACTION:
      return {
        ...state,
        loanConfig: action.loanConfig,
        levelConfig: action.levelConfig,
      };
    case SET_ALL_LOAN_DETAILS:
      return { 
        ...state,
        allLoanDetails: action.allLoanDetails,
        applyLoanConfig: {
          ...state.applyLoanConfig,
          minimartCode: action.allLoanDetails.applyLoanConfig.minimartCode,
          loanApplicationId: action.allLoanDetails.applyLoanConfig.loanApplicationId,
          loanStatus: action.allLoanDetails.applyLoanConfig.loanStatus ? action.allLoanDetails.applyLoanConfig.loanStatus : '',
          type: action.allLoanDetails.applyLoanConfig.type ? action.allLoanDetails.applyLoanConfig.type : '',
          docRequire: action.allLoanDetails.applyLoanConfig.docRequire ? action.allLoanDetails.applyLoanConfig.docRequire : false,
          externalInvoiceRequire: action.allLoanDetails.applyLoanConfig.externalInvoiceRequire ? action.allLoanDetails.applyLoanConfig.externalInvoiceRequire : false,
          updateConsumerLoan: action.allLoanDetails.applyLoanConfig.updateConsumerLoan ? action.allLoanDetails.applyLoanConfig.updateConsumerLoan : false,
        },
        invalidFormField: action.allLoanDetails.invalidFormField ? action.allLoanDetails.invalidFormField : [],
        loanInfo: action.allLoanDetails.loanInfo ?
          {
            ...state.loanInfo,
            amountRequested: action.allLoanDetails.loanInfo.amountRequested,
            amountApproved: action.allLoanDetails.loanInfo.amountApproved ? action.allLoanDetails.loanInfo.amountApproved : 0,
            termRequested: action.allLoanDetails.loanInfo.termRequested,
            emi: action.allLoanDetails.loanInfo.emi,
            interestRate: action.allLoanDetails.loanInfo.interestRate,
            type: action.allLoanDetails.loanInfo.type,
            invoiceNumber: action.allLoanDetails.loanInfo.invoiceNumber,
            selectedTerm: action.allLoanDetails.loanInfo.termRequested !== 0 ? ((action.allLoanDetails.loanInfo.termRequested / 3) - 2) : 0,
            supplierName: action.allLoanDetails.loanInfo.supplierName ? action.allLoanDetails.loanInfo.supplierName : '',
            prefillData: action.allLoanDetails.loanStatus !== "DISBURSED",
            productCost: action.allLoanDetails.loanInfo.productCost ? action.allLoanDetails.loanInfo.productCost : 0,
            frequency: action.allLoanDetails.loanInfo.frequency ? action.allLoanDetails.loanInfo.frequency : '',
            selectedDisbursementType: action.allLoanDetails.loanInfo?.selectedDisbursementType ? action.allLoanDetails.loanInfo.selectedDisbursementType : null,
            supplierDetails: action.allLoanDetails.loanInfo?.supplierDetails ? action.allLoanDetails.loanInfo.supplierDetails : null,
            selectedTransferAccountType: action.allLoanDetails.loanInfo?.selectedTransferAccountType ? action.allLoanDetails.loanInfo.selectedTransferAccountType : null,
            accountInfo: action.allLoanDetails.loanInfo?.accountInfo ? action.allLoanDetails.loanInfo.accountInfo : null,
            supplierId: action.allLoanDetails.loanInfo?.supplierId ? action.allLoanDetails.loanInfo.supplierId : null,
            collectionDays: action.allLoanDetails.loanInfo?.collectionDays ? action.allLoanDetails.loanInfo.collectionDays : null,
            currentEmi: action.allLoanDetails.loanInfo?.currentEmi ? action.allLoanDetails.loanInfo.currentEmi : 0,
            startDate: action.allLoanDetails.loanInfo?.startDate ? action.allLoanDetails.loanInfo.startDate : null,
            endDate: action.allLoanDetails.loanInfo?.endDate ? action.allLoanDetails.loanInfo.endDate : null,
            ilaff: !action.allLoanDetails.loanInfo?.ilaff ? action.allLoanDetails.loanInfo.ilaff : 1,
          } : {
            amountRequested: 0,
            amountApproved: 0,
            termRequested: 0,
            emi: 0,
            interestRate: 0,
            type: 0,
            invoiceNumber: 0,
            selectedTerm: 0,
            supplierName: '',
            prefillData: false,
            productCost: 0,
            frequency: '',
            selectedDisbursementType: null,
            supplierDetails: null,
            selectedTransferAccountType: null,
            accountInfo: null,
            supplierId: null,
            collectionDays: null,
            currentEmi: 0,
            startDate: null,
            endDate: null,
            ilaff: 1,
          },
        basicInfo: action.allLoanDetails.basicInfo ? {
          ...state.basicInfo,
          ciCustomerSinceYears: action.allLoanDetails.basicInfo.ciCustomerSinceYears,
          businessEstablishedSinceYears: action.allLoanDetails.basicInfo.businessEstablishedSinceYears,
          telephone: action.allLoanDetails.basicInfo.telephone,
          ownerName: action.allLoanDetails.basicInfo.ownerName,
          ownerId: action.allLoanDetails.basicInfo.ownerId,
          ownerAddress: action.allLoanDetails.basicInfo.ownerAddress,
          ownerNumber: action.allLoanDetails.basicInfo.ownerNumber,
          adminName: action.allLoanDetails.basicInfo.adminName,
          adminId: action.allLoanDetails.basicInfo.adminId,
          adminNumber: action.allLoanDetails.basicInfo.adminNumber,
          adminSince: action.allLoanDetails.basicInfo.adminSince,
          adminAddress: action.allLoanDetails.basicInfo.adminAddress,
          adminSalary: action.allLoanDetails.basicInfo.adminSalary,
          holder: action.allLoanDetails.basicInfo.holder,
          ownerDateOfBirth: action.allLoanDetails.basicInfo.ownerDateOfBirth,
          adminDateOfBirth: action.allLoanDetails.basicInfo.adminDateOfBirth,
          ciCreditLimit: action.allLoanDetails.basicInfo.ciCreditLimit,
          prefillData: true,
          ownerHomeType: action.allLoanDetails.basicInfo.ownerHomeType,
          familyMembers: "" + action.allLoanDetails.basicInfo.familyMembers,
          numberOfVehicles: "" + action.allLoanDetails.basicInfo.numberOfVehicles,
          bankAccount: action.allLoanDetails.basicInfo.bankAccount == null ? false : action.allLoanDetails.basicInfo.bankAccount,
          bankDetail: action.allLoanDetails.basicInfo.bankAccount ? action.allLoanDetails.basicInfo.bankDetail : null,
          receivesRemittances: action.allLoanDetails.basicInfo.receivesRemittances == null ? false : action.allLoanDetails.basicInfo.receivesRemittances,
          remittanceDetails: action.allLoanDetails.basicInfo.receivesRemittances ? action.allLoanDetails.basicInfo.remittanceDetails : null,
          socialMediaAccount: action.allLoanDetails.basicInfo.socialMediaAccount == null ? false : action.allLoanDetails.basicInfo.socialMediaAccount,
          socialMediaAccountDetails: action.allLoanDetails.basicInfo.socialMediaAccountDetails ? action.allLoanDetails.basicInfo.socialMediaAccountDetails : null,
          homeLocation: action.allLoanDetails.basicInfo.homeLocation,
          businessType: action.allLoanDetails.basicInfo.businessType,

        } : {
          ...state.basicInfo,
          ciCustomerSinceYears: null,
          businessEstablishedSinceYears: null,
          telephone: null,
          ownerName: null,
          ownerId: null,
          ownerAddress: null,
          ownerNumber: null,
          adminName: null,
          adminId: null,
          adminNumber: null,
          holder: "",
          ownerDateOfBirth: null,
          adminDateOfBirth: null,
          ciCreditLimit: null,
          prefillData: false,
          ownerHomeType: null,
          familyMembers: null,
          numberOfVehicles: null,
          bankAccount: false,
          bankDetail: null,
          receivesRemittances: false,
          remittanceDetails: null,
          socialMediaAccount: false,
          socialMediaAccountDetails: null,
          homeLocation: null,
          adminSince: null,
          adminAddress: null,
          adminSalary: null,
          businessType: null,
        },
        additionalInfo: action.allLoanDetails.additionalInfo ? {
          ...state.additionalInfo,
          comercialRef1: {
            name: action.allLoanDetails.additionalInfo.comercialRef1.name,
            address: action.allLoanDetails.additionalInfo.comercialRef1.address,
            phone: action.allLoanDetails.additionalInfo.comercialRef1.phone
          },
          comercialRef2: {
            name: action.allLoanDetails.additionalInfo.comercialRef2.name,
            address: action.allLoanDetails.additionalInfo.comercialRef2.address,
            phone: action.allLoanDetails.additionalInfo.comercialRef2.phone
          },
          personalRef1: {
            name: action.allLoanDetails.additionalInfo.personalRef1.name,
            address: action.allLoanDetails.additionalInfo.personalRef1.address,
            phone: action.allLoanDetails.additionalInfo.personalRef1.phone
          },
          personalRef2: {
            name: (action.allLoanDetails.additionalInfo.personalRef2?.name) ? action.allLoanDetails.additionalInfo.personalRef2.name : null,
            address: (action.allLoanDetails.additionalInfo.personalRef2?.addres) ? action.allLoanDetails.additionalInfo.personalRef2.address : null,
            phone: (action.allLoanDetails.additionalInfo.personalRef2?.phone) ? action.allLoanDetails.additionalInfo.personalRef2.phone : null
          },
          neighbourhoodRef1: {
            name: action.allLoanDetails.additionalInfo.neighbourhoodRef1.name,
            address: action.allLoanDetails.additionalInfo.neighbourhoodRef1.address,
            phone: action.allLoanDetails.additionalInfo.neighbourhoodRef1.phone
          },
          neighbourhoodRef2: {
            name: (action.allLoanDetails.additionalInfo.neighbourhoodRef2?.name) ? action.allLoanDetails.additionalInfo.neighbourhoodRef2.name : null,
            address: (action.allLoanDetails.additionalInfo.neighbourhoodRef2?.address) ? action.allLoanDetails.additionalInfo.neighbourhoodRef2.address : null,
            phone: (action.allLoanDetails.additionalInfo.neighbourhoodRef2?.phone) ? action.allLoanDetails.additionalInfo.neighbourhoodRef2.phone : null
          },
          prefillData: true,
        } : {
          ...state.additionalInfo,
          comercialRef1: {
            name: null,
            address: null,
            phone: null
          },
          comercialRef2: {
            name: null,
            address: null,
            phone: null
          },
          personalRef1: {
            name: null,
            address: null,
            phone: null
          },
          personalRef2: {
            name: null,
            address: null,
            phone: null
          },
          neighbourhoodRef1: {
            name: null,
            address: null,
            phone: null
          },
          neighbourhoodRef2: {
            name: null,
            address: null,
            phone: null
          },
          prefillData: false,
        },
        income: action.allLoanDetails.income ? {
          ...state.income,
          monthlyIncome: "" + action.allLoanDetails.income.monthlyIncome,
          monthlySalesAmount: "" + action.allLoanDetails.income.monthlySalesAmount,
          accountsPending: "" + action.allLoanDetails.income.accountsPending,
          inventory: "" + action.allLoanDetails.income.inventory
        } : {
          ...state.income,
          monthlyIncome: "",
          monthlySalesAmount: "",
          accountsPending: "",
          inventory: ""
        },
        expenses: action.allLoanDetails.expenses ? {
          ...state.expenses,
          numberOfEmployees: "" + action.allLoanDetails.expenses.numberOfEmployees,
          salaryOfEmployees: "" + action.allLoanDetails.expenses.salaryOfEmployees,
          rent: "" + action.allLoanDetails.expenses.rent,
          electricity: "" + action.allLoanDetails.expenses.electricity,
          water: "" + action.allLoanDetails.expenses.water,
          telephone: "" + action.allLoanDetails.expenses.telephone,
          internet: "" + action.allLoanDetails.expenses.internet,
          gas: "" + action.allLoanDetails.expenses.gas,
          debtsToSuppliers: "" + action.allLoanDetails.expenses.debtsToSuppliers,
          prefillData: true,
        } : {
          ...state.expenses,
          numberOfEmployees: "",
          salaryOfEmployees: "",
          rent: "",
          electricity: "",
          water: "",
          telephone: "",
          internet: "",
          gas: "",
          debtsToSuppliers: "",
          prefillData: false,
        },
        siteVisit: action.allLoanDetails.siteVisit ? {
          ...state.siteVisit,
          numberOfMotors: "" + action.allLoanDetails.siteVisit.numberOfMotors,
          numberOfFreezers: "" + action.allLoanDetails.siteVisit.numberOfFreezers,
          numberOfExhibitors: "" + action.allLoanDetails.siteVisit.numberOfExhibitors,
          numberOfBotellero: "" + action.allLoanDetails.siteVisit.numberOfBotellero,
          numberOfFridges: "" + action.allLoanDetails.siteVisit.numberOfFridges,
          numberOfTelephones: "" + action.allLoanDetails.siteVisit.numberOfTelephones,
          numberOfCars: "" + action.allLoanDetails.siteVisit.numberOfCars,
          numberOfTVs: "" + action.allLoanDetails.siteVisit.numberOfTVs,
          localType: action.allLoanDetails.siteVisit.localType,
          prefillData: true,
          investor: action.allLoanDetails.siteVisit.investor,
          roofType: action.allLoanDetails.siteVisit.roofType
        } : {
          ...state.siteVisit,
          numberOfMotors: '',
          numberOfFreezers: '',
          numberOfExhibitors: '',
          numberOfBotellero: '',
          numberOfFridges: '',
          numberOfTelephones: '',
          numberOfCars: '',
          numberOfTVs: '',
          localType: 'RENTED',
          prefillData: false,
          investor: false,
          roofType: ''
        },
        documents: action.allLoanDetails.documents ? action.allLoanDetails.documents : INITIAL_STATE.documents,
        docPrefillData: action.allLoanDetails.documents.length > 3,
      }
      
    case SET_CREDIT_PRODUCT_INPUT_DATA:
      return {
        ...state,
        loanInfo: {
          amountRequested: action.loanInfo.amount,
          amountApproved: action.loanInfo.amountApproved ?? 0,
          termRequested: action.loanInfo.term,
          emi: action.loanInfo.emi ?? null,
          interestRate: action.loanInfo.interestRate ?? null,
          type: action.loanInfo.type ?? null,
          invoiceNumber: action.loanInfo.invoiceNumber ?? null,
          selectedTerm: action.loanInfo.selectedTerm ?? 0,
          supplierName: action.loanInfo.supplierName ?? '',
          productCost: action.loanInfo.productCost ?? 0,
          frequency: action.loanInfo.frequency ?? '',
          selectedDisbursementType: action.loanInfo.selectedDisbursementType ?? null,
          supplierDetails:{
            ...state.loanInfo.supplierDetails,
            businessName: action.loanInfo.businessName ?? null,
          },
          selectedTransferAccountType: action.loanInfo.selectedTransferAccountType ?? null,
          prefillData: true,
          accountInfo: (action.loanInfo.bankName || action.loanInfo.accountType || action.loanInfo.accountNumber)
          ? {
              bankName: action.loanInfo.bankName ?? null,
              accountType: action.loanInfo.accountType ?? null,
              accountNumber: action.loanInfo.accountNumber ?? null,
            }
          : null,
          supplierId: action.loanInfo.supplierId ?? null,
          collectionDays: action.loanInfo.collectionDays ?? null,
          currentEmi: action.loanInfo.currentEmi ?? 0,
          startDate: action.loanInfo.startDate ?? null,
          endDate: action.loanInfo.endDate ?? null,
          ilaff: action.loanInfo.ilaff ?? 1,
        },
      }
    case SET_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT:
      return {
        ...state,
        creditProductInputDataForEdit: action.creditProductInputDataForEdit,
      }
    case SET_BASIC_INFORMATION_DATA:
      
      return {
        ...state,
        basicInfo: {
          ...state.basicInfo,
          ciCustomerSinceYears: action.basicInfo.ciCustomerSinceYears,
          businessEstablishedSinceYears: action.basicInfo.businessEstablishedSinceYears,
          telephone: action.basicInfo.telephone,
          ownerName: action.basicInfo.ownerName,
          ownerId: action.basicInfo.ownerId,
          ownerAddress: action.basicInfo.ownerAddress,
          ownerNumber: action.basicInfo.ownerNumber,
          adminName: action.basicInfo.adminName,
          adminId: action.basicInfo.adminId,
          adminNumber: action.basicInfo.adminNumber,
          holder: action.basicInfo.holder,
          ownerDateOfBirth: action.basicInfo.ownerDateOfBirth,
          adminDateOfBirth: action.basicInfo.adminDateOfBirth,
          ciCreditLimit: action.basicInfo.ciCreditLimit,
          prefillData: true,
          ownerHomeType: action.basicInfo.ownerHomeType,
          familyMembers: action.basicInfo.familyMembers,
          numberOfVehicles: action.basicInfo.numberOfVehicles,
          bankAccount: action.basicInfo.bankAccount == null ? false : action.basicInfo.bankAccount,
          bankDetail: action.basicInfo.bankAccount ? action.basicInfo.bankDetail : null,
          receivesRemittances: action.basicInfo.receivesRemittances == null ? false : action.basicInfo.receivesRemittances,
          remittanceDetails: action.basicInfo.receivesRemittances ? action.basicInfo.remittanceDetails : null,
          socialMediaAccount: action.basicInfo.socialMediaAccount == null ? false : action.basicInfo.socialMediaAccount,
          socialMediaAccountDetails: action.basicInfo.socialMediaAccountDetails ? action.basicInfo.socialMediaAccountDetails : null,
          homeLocation: action.basicInfo.homeLocation,
          adminSince: action.basicInfo.adminSince,
          adminAddress: action.basicInfo.adminAddress,
          adminSalary: action.basicInfo.adminSalary,
          businessType: action.basicInfo.businessType,
        }
      }
    case SET_REFERENCES_DATA:
      return {
        ...state,
        additionalInfo: {
          prefillData: true,
          comercialRef1: {
            name: action.additionalInfo.comercialRef1?.name ?? null,
            address: action.additionalInfo.comercialRef1?.address ?? null,
            phone: action.additionalInfo.comercialRef1?.phone ?? null
          },
          comercialRef2: {
            name: action.additionalInfo.comercialRef2?.name ?? null,
            address: action.additionalInfo.comercialRef2?.address ?? null,
            phone: action.additionalInfo.comercialRef2?.phone ??null
          },
          personalRef1: {
            name: action.additionalInfo.personalRef1?.name ?? null,
            address: action.additionalInfo.personalRef1?.address ?? null,
            phone: action.additionalInfo.personalRef1?.phone ?? null
          },
          personalRef2: {
            name: action.additionalInfo.personalRef2?.name ?? null,
            address: action.additionalInfo.personalRef2?.address ?? null,
            phone: action.additionalInfo.personalRef2?.phone ?? null
          },
          neighbourhoodRef1: {
            name: action.additionalInfo.neighbourhoodRef1?.name ?? null,
            address: action.additionalInfo.neighbourhoodRef1?.address ?? null,
            phone: action.additionalInfo.neighbourhoodRef1?.phone ??null
          },
          neighbourhoodRef2: {
            name: action.additionalInfo.neighbourhoodRef2?.name ?? null,
            address: action.additionalInfo.neighbourhoodRef2?.address ?? null,
            phone: action.additionalInfo.neighbourhoodRef2?.phone ?? null
          }
        },
      }
    case SET_FINANCIAL_INFORMATION_DATA:
      return {
        ...state,
        expenses: {
          ...state.expenses,
          numberOfEmployees: action.expenses.numberOfEmployees,
          salaryOfEmployees: action.expenses.salaryOfEmployees,
          rent: action.expenses.rent,
          electricity: action.expenses.electricity,
          water: action.expenses.water,
          telephone: action.expenses.telephone,
          internet: action.expenses.internet,
          gas: action.expenses.gas,
          debtsToSuppliers: action.expenses.debtsToSuppliers,
          prefillData: true,
        }
      }
    case SET_INCOME_DATA:
      return {
        ...state,
        income: action.income,
      }
    case SET_SITE_VISIT_DATA:
      return {
        ...state,
        siteVisit: {
          ...state.siteVisit,
          numberOfMotors: action.siteVisit.numberOfMotors,
          numberOfFreezers: action.siteVisit.numberOfFreezers,
          numberOfExhibitors: action.siteVisit.numberOfExhibitors,
          numberOfBotellero: action.siteVisit.numberOfBotellero,
          numberOfFridges: action.siteVisit.numberOfFridges,
          numberOfTelephones: action.siteVisit.numberOfTelephones,
          numberOfCars: action.siteVisit.numberOfCars,
          numberOfTVs: action.siteVisit.numberOfTVs,
          prefillData: true,
          investor: action.siteVisit.investor,
          roofType: action.siteVisit.roofType,
          localType: action.siteVisit.localType,
        }
      }
    case SET_EVIDENCE_DATA:
      return {
        ...state,
        documents: action.documents,
        docPrefillData: true,
      }
    case SET_APPLY_LOAN_CONFIG_DATA:
      return {
        ...state,
        applyLoanConfig: {
          ...state.applyLoanConfig,
          minimartCode: action.applyLoanConfig.minimartCode,
          loanStatus: action.applyLoanConfig.loanStatus ? action.applyLoanConfig.loanStatus : "",
          type: action.applyLoanConfig.type ? action.applyLoanConfig.type : "",
          updateConsumerLoan: action.applyLoanConfig.updateConsumerLoan ? action.applyLoanConfig.updateConsumerLoan : false,
          docRequire: action.applyLoanConfig.docRequire ? action.applyLoanConfig.docRequire : false,
          externalInvoiceRequire: action.applyLoanConfig.externalInvoiceRequire ? action.applyLoanConfig.externalInvoiceRequire : false,
          loanApplicationId: action.applyLoanConfig.loanApplicationId,
        },
      }
    case UPDATE_DOC_REQUIRE_CONFIG:
      const { applyLoanConfig } = state;
      const updatedApplyLoanConfig = {
          ...applyLoanConfig,
          docRequire: action.documentStatus.docRequire,
          externalInvoiceRequire: action.documentStatus.externalInvoiceRequire,
      }
      return {
          ...state,
          applyLoanConfig: updatedApplyLoanConfig,
          documents: action.documentStatus.documents,
          docPrefillData: !action.documentStatus.docRequire,
      }
    case UPDATE_DOCPREFILL_DATA:
      return {
        ...state,
        docPrefillData: action.docPrefillData,
      }
    case UPDATE_INVALID_FORM_FIELD:
      let updatedInvalidFormField = state.invalidFormField.map(field => {
        if(field.ft === action.loanStep){
          return {
            ...field,
            ff: [],
          }
        }
        return field;
      });
      return {
        ...state,
        invalidFormField: updatedInvalidFormField,
      }
    case CLEAR_CREDIT_PRODUCT_INPUT_DATA:
      return {
        ...state,
        loanInfo: INITIAL_STATE.loanInfo,
      }
    case CLEAR_CREDIT_PRODUCT_INPUT_DATA_FOR_EDIT:
      return {
        ...state,
        creditProductInputDataForEdit: INITIAL_STATE.creditProductInputDataForEdit,
      }
    case CLEAR_BASIC_INFORMATION_DATA:
      return {
        ...state,
        basicInfo: INITIAL_STATE.basicInfo,
      }
    case CLEAR_REFERENCES_DATA:
      return {
        ...state,
        additionalInfo: INITIAL_STATE.additionalInfo,
      }
    case CLEAR_FINANCIAL_INFORMATION_DATA:
      return {
        ...state,
        expenses: INITIAL_STATE.expenses,
        income: INITIAL_STATE.income,
      }
    case CLEAR_SITE_VISIT_DATA:
      return {
        ...state,
        siteVisit: INITIAL_STATE.siteVisit,
      }
    case CLEAR_EVIDENCE_DATA:
      return {
        ...state,
        documents: INITIAL_STATE.documents,
        docPrefillData: false,
      }
    case CLEAR_SET_ALL_LOAN_DETAILS:
      return {
        ...state,
        applyLoanConfig: INITIAL_STATE.applyLoanConfig,
        allLoanDetails: INITIAL_STATE.allLoanDetails,
        basicInfo: INITIAL_STATE.basicInfo,
        loanInfo: INITIAL_STATE.loanInfo,
        additionalInfo: INITIAL_STATE.additionalInfo,
        expenses: INITIAL_STATE.expenses,
        siteVisit: INITIAL_STATE.siteVisit,
        documents: INITIAL_STATE.documents,
        income: INITIAL_STATE.income,
        creditProductInputDataForEdit: INITIAL_STATE.creditProductInputDataForEdit,
        docPrefillData: false,
        invalidFormField: INITIAL_STATE.invalidFormField,
      }
    default:
      return state;
  }
}
